<template>
  <div class="matrix-auto">
    <matrix-form :rows="issue.rows">
      <template v-slot:row-icon="{ index }">
        <span class="absolute top-0 right-0" v-if="index === issue.rows.length - 1 && issue.rows.length > issue.min_row_num">
          <van-icon name="close" @click="onDeleteRow(index)" />
        </span>
      </template>
      <template v-slot:content="{ row }">
        <div class="bg-card-bg-gray px-3 py-2">
          <div v-for="item in issue.items" :key="item.id" class="mb-2 last:mb-0">
            <div class="my-1 rich-text-wrap" v-html="item.content.richText"></div>
            <compose-item
              :row="row"
              :col="item"
              :cell="issue.getCellByItemId(item.id)"
              :cache-value="issue.getValueByRowAndCol(row, item)"
              @change="onChangeValue"
            />
            <template v-if="row.errMap[item.id]">
              <span class="text-red mt-1 text-small">{{ row.errMap[item.id] }}</span>
            </template>
          </div>
        </div>
      </template>
    </matrix-form>
    <template v-if="issue.can_add_row && issue.rows.length < issue.max_row_num">
      <van-button size="small" block class="mt-2" plain type="primary" @click="addRow">继续填写</van-button>
    </template>
  </div>
</template>

<script>
import MatrixForm from '@/questions/components/MatrixForm'
import ComposeItem from '@/questions/matrix/ComposeItem'

export default {
  name: 'MatrixAuto',
  changeExpr: 'issue.value',
  components: { ComposeItem, MatrixForm },
  methods: {
    onChangeValue(value) {
      this.issue.addValue(value.slice())
    },
    addRow() {
      this.issue.addRow()
    },
    onDeleteRow(index) {
      this.issue.deleteRow(index)
    }
  }
}
</script>
